import { BaseNodeModel } from "@/models/nodes/BaseNodeModel";

import { SymbolNodeModel } from "./SymbolNodeModel";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeId } from "@/models/nodes/types";
import type { VisitableNode, NodeVisitor } from "@/models/nodes/visitors/NodeVisitor";
import type { OperatorSymbolNodeProps, OperatorSymbolNodeConstructorProps } from "@corca/data";

export { OperatorType, operators } from "@/models/nodes/operators";

export class OperatorSymbolNodeModel
  extends BaseNodeModel<OperatorSymbolNodeProps>
  implements VisitableNode
{
  static type = "operatorSymbol" as const;

  type = OperatorSymbolNodeModel.type;

  protected fillRequiredProps(props: OperatorSymbolNodeConstructorProps): OperatorSymbolNodeProps {
    return props;
  }

  static create(
    doc: DocumentModel,
    value: string | SymbolNodeModel,
    props: OperatorSymbolNodeConstructorProps = {},
    id?: NodeId,
  ) {
    const symbolNode = typeof value === "string" ? doc.create(SymbolNodeModel, value) : value;
    return new OperatorSymbolNodeModel(doc, id, props, [symbolNode]);
  }

  get isEditable(): boolean {
    return false;
  }

  get symbolNode() {
    return this.descendants.find((n) => n.is(SymbolNodeModel));
  }

  get value(): string {
    return this.symbolNode?.props?.value || "";
  }

  get name() {
    return this.props.name || "";
  }

  get semanticTypes() {
    return this.props.semanticType;
  }

  accept<R>(visitor: NodeVisitor<R>): R {
    return visitor.visitOperatorSymbolNode(this);
  }
}
